// Whether a page's down caret still has somewhere worth going: something
// below the screen before the site footer. Once the footer shows, the page is
// done, and a caret fixed at the foot of the screen would only sit over the
// footer's links, as the catalog's did: it measured only whether the page
// could scroll at all, so it stayed up all the way down. Shared by the
// catalog (FeaturedPage) and the home page, whose carets are the same.
// Without a laid-out footer (a page that hides it), whatever is left below
// the screen counts, less a 40px margin.
export function hasMoreBelow() {
  const footer = document.querySelector(".site-footer");
  const r = footer ? footer.getBoundingClientRect() : null;
  if (r && r.height > 0) return r.top > window.innerHeight;
  return window.scrollY + window.innerHeight < document.documentElement.scrollHeight - 40;
}
